module.exports = __webpack_public_path__ + "static/ms-icon-144x144-3addeb60946bef8ae89e63a7cd137171.png";